import { ROUTES_CHALLENGES_PUBLIC, ROUTES_CHALLENGE_SINGLE_PUBLIC } from '@/constants/routes';

export default {
    path: '/',
    name: 'challenges-board-public',
    redirect: '/',
    component: () => import(/* webpackChunkName: 'challenges-public' */ '@/views/ChallengesPublic.vue'),
    children: [
        {
            path: '/',
            name: ROUTES_CHALLENGES_PUBLIC,
            component: () =>
                import(/* webpackChunkName: 'challenges-public' */ '@/components/challenges/public/board/Challenges.vue'),
        },
        {
            path: '/challenges/:challengeSlug',
            name: ROUTES_CHALLENGE_SINGLE_PUBLIC,
            component: () =>
                import(/*webpackChunkName: 'challenges-public'*/ '@/components/challenges/public/single/ChallengesSingle.vue')
        }
    ]
};
